export default __webpack_public_path__ + "static/media/Maggie Smith.1f85405b.webp";